import type { WeaponSkin } from '../../../engine/content/schema/weapon';

/**
 * Curated starting skins for the material editor's preset rail. Each preset
 * is a real, complete WeaponSkin - "empty" parts intentionally leave a role
 * untouched (the chassis/component's own loaded finish shows through, per
 * @sstk/weapon-kit's materials-and-skins.md), not a placeholder.
 */
export const SKIN_PRESETS: WeaponSkin[] = [
  { id: 'factory', name: 'Factory', parts: {} },
  {
    id: 'tactical-black',
    name: 'Tactical Black',
    parts: {
      frame: { color: 0x14151a, roughness: 0.55, metalness: 0.2 },
      metal: { color: 0x1c1d21, roughness: 0.35, metalness: 0.85 },
      detail: { color: 0x2a2c33, roughness: 0.5, metalness: 0.3 },
    },
  },
  {
    id: 'desert-tan',
    name: 'Desert Tan',
    parts: {
      frame: { color: 0xc9a876, roughness: 0.75, metalness: 0.05 },
      furniture: { color: 0xb8935f, roughness: 0.8, metalness: 0 },
      metal: { color: 0x8a7355, roughness: 0.4, metalness: 0.7 },
    },
  },
  {
    id: 'arctic-white',
    name: 'Arctic White',
    parts: {
      frame: { color: 0xe8e9ec, roughness: 0.5, metalness: 0.1 },
      furniture: { color: 0xd6d8dc, roughness: 0.6, metalness: 0 },
      metal: { color: 0xaeb2b8, roughness: 0.3, metalness: 0.75 },
      detail: { color: 0x9099a3, roughness: 0.4, metalness: 0.4 },
    },
  },
  {
    id: 'cobalt',
    name: 'Cobalt',
    parts: {
      frame: { color: 0x1c3f6e, roughness: 0.3, metalness: 0.55 },
      metal: { color: 0x0e2038, roughness: 0.25, metalness: 0.9 },
      detail: { color: 0x3d7ac0, roughness: 0.35, metalness: 0.6 },
    },
  },
  {
    id: 'rift-cell',
    name: 'Rift Cell',
    parts: {
      frame: { color: 0x0e0f13, roughness: 0.6, metalness: 0.25 },
      metal: { color: 0x16171c, roughness: 0.4, metalness: 0.8 },
      energy: { color: 0x0a0a0f, roughness: 0.2, metalness: 0.1, emissive: 0x9d5cff, emissiveIntensity: 2.2 },
      optic: { color: 0x0a0a0f, roughness: 0.15, metalness: 0.1, emissive: 0x5ce1ff, emissiveIntensity: 1.6 },
      sight: { color: 0x0a0a0f, roughness: 0.15, metalness: 0.1, emissive: 0x5ce1ff, emissiveIntensity: 1.4 },
    },
  },
];
